module.exports = "MessageFormat.locale.fr=function(n){return Math.floor(n)===0||Math.floor(n)==1?\"one\":\"other\"}\n"